export default "__VITE_ASSET__BpYqkxI0__"